'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _createAccountForm = require('./create-account-form');

var _createAccountForm2 = _interopRequireDefault(_createAccountForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var CreateAccount = _react2['default'].createClass({
    displayName: 'CreateAccount',


    propTypes: {
        'header': _react2['default'].PropTypes.string.isRequired,
        'googleOpenIdUrl': _react2['default'].PropTypes.string,
        'isFromApiPricing': _react2['default'].PropTypes.bool,
        'isInline': _react2['default'].PropTypes.bool,
        'isVertical': _react2['default'].PropTypes.bool, // only for inline
        'inlineSideText': _react2['default'].PropTypes.string,
        'tabOffset': _react2['default'].PropTypes.number,
        'signupForm': _react2['default'].PropTypes.object.isRequired, // Serialized sfForm
        'signupUrl': _react2['default'].PropTypes.string,
        'redirectUrl': _react2['default'].PropTypes.string,
        'recoverPasswordForm': _react2['default'].PropTypes.object, // Serialized sfForm
        'loginForm': _react2['default'].PropTypes.object, // Serialized sfForm
        'hideRememberMe': _react2['default'].PropTypes.bool,
        'hideGoogleOpenId': _react2['default'].PropTypes.bool,
        'async': _react2['default'].PropTypes.bool
    },

    getDefaultProps: function getDefaultProps() {
        return {
            'signupUrl': '/account/signUp'
        };
    },
    getInitialState: function getInitialState() {
        return {
            'password': '',
            'emailAddress': '',
            'isProcessing': false,
            'isInline': false,
            'isVertical': false
        };
    },
    componentDidMount: function componentDidMount() {
        if (!this.props.isInline && process.env.NODE_ENV !== 'test') {
            $(document).foundation();
            $(_reactDom2['default'].findDOMNode(this)).closest('.reveal-modal').foundation('reveal', 'open');
        }
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        if (!nextProps.isInline && process.env.NODE_ENV !== 'test') {
            $(_reactDom2['default'].findDOMNode(this)).closest('.reveal-modal').foundation('reveal', 'open');
        }
    },
    render: function render() {
        return _react2['default'].createElement(
            'div',
            null,
            _react2['default'].createElement(_createAccountForm2['default'], {
                header: this.props.header,
                buttonText: this.props.buttonText,
                isInline: this.props.isInline,
                isVertical: this.props.isVertical,
                inlineSideText: this.props.inlineSideText,
                googleOpenIdUrl: this.props.googleOpenIdUrl,
                redirectUrl: this.props.redirectUrl,
                isFromApiPricing: this.props.isFromApiPricing,
                planId: this.props.planId,
                tabOffset: this.props.tabOffset,
                fields: this.props.signupForm.fields,
                values: this.props.signupForm.values,
                namespace: this.props.signupForm.namespace,
                action: this.props.signupUrl,
                recoverPasswordForm: this.props.recoverPasswordForm,
                loginForm: this.props.loginForm,
                hideRememberMe: this.props.hideRememberMe,
                hideGoogleOpenId: this.props.hideGoogleOpenId,
                async: this.props.async })
        );
    }
});

module.exports = CreateAccount;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/auth/create-account.jsx
 ** module id = 872
 ** module chunks = 0
 **/